import { Pipe, PipeTransform } from '@angular/core';
import { DocSizeError } from '@common/html/constants/doc-size-error.constant';
import { FileSizeService } from '@portal-core/general/services/file-size.service';
import { TextEditorService } from '@portal-core/text-editor/services/text-editor.service';

@Pipe({
  name: 'mcCollabValidationErrorText'
})
export class CollabValidationErrorTextPipe implements PipeTransform {
  constructor(private fileSizeService: FileSizeService, private textEditorService: TextEditorService) { }

  transform(error: Error): string {
    // Use a custom message for the doc size error
    if (error?.name === DocSizeError) {
      return `Document is too large. Current size: ${this.fileSizeService.format((error as any).docSize, 2)}. Max size: ${this.fileSizeService.format(this.textEditorService.flareTextEditorDocMaxCharLength, 0)}.`;
    }
    // Else display the error name and message if they exist
    else if (error?.name || error?.message) {
      return `${error.name ? error.name + ': ' : ''}${error.message ?? ''}`;
    }
  }
}
